import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Tabs } from '@com-delta-omnichannel/mach-core-js';
import * as WidgetTabsConstants from './constants/widget-tabs.constants';
import {
  BookingCategoryType,
  WidgetTabs
} from './models/widget-tabs.interfaces';

@Component({
  selector: 'idp-widget-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './widget-tabs.component.html',
  styleUrls: ['./widget-tabs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WidgetTabsComponent implements AfterViewInit {
  @Input() content: WidgetTabs = {} as WidgetTabs;
  @Input() bookingTab: string = {} as string;
  @Output() externalLinkEmit = new EventEmitter<string>();
  @Output() tabSelectEmit = new EventEmitter<BookingCategoryType>();
  @Output() externalLinkTracking = new EventEmitter<HTMLElement>();
  @Output() tabClickTracking = new EventEmitter<BookingCategoryType>();
  selectedIndexPanel = 0;
  tabsBookingInstance!: Tabs;
  currentTabId!: BookingCategoryType;
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();

  ngAfterViewInit(): void {
    if (!this.content.tabBookingOptions) return;

    this.tabsBookingInstance = new Tabs(this.content.tabBookingOptions);
    this.onTabClick();
    this.currentTabId =
      this.tabsBookingInstance.getSelectedTabId() as BookingCategoryType;
  }

  private isProgrammaticChange = false;

  onTabClick(): void {
    this.tabsBookingInstance.onTabChange((index, id) => {
      if (this.isProgrammaticChange) {
        this.isProgrammaticChange = false;
        return;
      }

      const category = id as BookingCategoryType;
      this.tabClickTracking.emit(category);

      if (category === WidgetTabsConstants.CRUISES) {
        const cruisesUrl =
          this.content.externalLinks?.links?.cruises ||
          WidgetTabsConstants.CRUISES_FALLBACK_URL;
        window.open(
          cruisesUrl,
          WidgetTabsConstants._BLANK,
          WidgetTabsConstants.NO_OPENER_NO_REFERRER
        );
        this.selectTabSilently(this.currentTabId);
        return;
      }

      this.currentTabId = id as BookingCategoryType;
      this.tabSelectEmit.emit(this.currentTabId);
      this.selectedIndexPanel = index;
    });
  }

  private selectTabSilently(tabId: BookingCategoryType): void {
    this.isProgrammaticChange = true;
    this.tabsBookingInstance.selectTabById(tabId);
  }

  onExternalClick(url: string): void {
    this.externalLinkEmit.emit(url);
  }

  onLinkClick(event: Event): void {
    const element = event.currentTarget as HTMLElement;
    this.externalLinkTracking.emit(element);
  }

  onSearchButtonClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (
      target.tagName === 'BUTTON' &&
      ((target as HTMLButtonElement).type === 'submit' ||
        target.textContent?.toLowerCase().includes('search'))
    ) {
      target.setAttribute(
        'data-acdl-action',
        `header:${this.currentTabId}:search`
      );
      target.setAttribute(
        'data-acdl-page-section',
        `header:${this.currentTabId}:search`
      );
      target.setAttribute('data-acdl-name', `${this.currentTabId}:search`);
      this.analyticsEvent.emit(target);
    }
  }
}
